import React, { Component } from "react";
import Script from "react-load-script";

import styles from "./About.css";

class Jobs extends Component {
  render() {
    return (
      <div className={styles.aboutSections}>
        <div className={styles.sectionHeaders}>
          <h4>Jobs at Axios</h4>
        </div>

        <div className={styles.aboutContent}>
          <div id="grnhse_app"></div>

          <Script url="https://boards.greenhouse.io/embed/job_board/js?for=axios" />
        </div>
      </div>
    );
  }
}

export default Jobs;



// WEBPACK FOOTER //
// ./src/about/components/About/Jobs.js